import * as autobind from 'autobind';
import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { nameof } from 'utils/object';
import { RequestWizardStore, RequestWizardData } from 'stores/requests/create-request-wizard-store';
import './step6-comments.less';
import moment from 'moment';
import { isExtendedWorkflow } from 'utils/event-type-utils';

interface TailwindStepCommentsProps extends WithTranslation {
  requestWizardStore?: RequestWizardStore;
}

@connect(['requestWizardStore', RequestWizardStore])
class TailwindStepComments extends Component<TailwindStepCommentsProps, any> {
  private get requestWizardStore() {
    return this.props.requestWizardStore;
  }

  constructor(props) {
    super(props);

    this.state = {};
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.requestWizardStore.change({ ...this.requestWizardStore.state.item, ...change });
  }

  private onManuallyChangeTitle = (val: string) => {
    if (!this.state.titleFocused) {
      const current = this.requestWizardStore.state.item.title;
      if (current !== val) {
        this.setState({ manualTitle: true, originalTitle: val }, () => this.onValueChanged(['title', val]));
      }
    } else {
      this.onValueChanged(['title', val]);
    }
  };

  private onValueChanged = (...changes: [string, any][]) => {
    const change = {};
    changes.forEach(([prop, value]) => {
      change[prop] = value;
    });
    this.requestWizardStore.change({
      ...this.requestWizardStore.state.item,
      ...change
    });
  };

  private getDateWithOutTimeZone = (date: Date) => {
    const myFormat = 'YYYY-MM-DD';
    return moment(date, 'YYYYMMDDTHHmmss')
      .format(myFormat)
      .split('-');
  };

  componentDidMount() {
    const { item } = this.requestWizardStore.state;
    const extendedWorkflow = isExtendedWorkflow(item.eventType.eventTypeCategory);

    if (extendedWorkflow) {
      const startDate = this.getDateWithOutTimeZone(item.startDate);
      const endDate = this.getDateWithOutTimeZone(item.endDate);

      let compoundTitle = '';
      compoundTitle = `${item.requestLocation?.title ?? ''} / ${item.eventType.name} / ${startDate[1]} - ${endDate[1]} / ${
        startDate[0]
      }`.trim();
      this.onManuallyChangeTitle(compoundTitle);
    }
  }

  render() {
    const { t } = this.props as any;
    const { titleFocused } = this.state;
    return (
      <form className="space-y-6 p-4 sm:p-6">
        <div className="flex flex-col">
          <label className="mb-2 text-sm font-medium text-gray-700">{t('Request Title')}</label>
          <input
            value={this.requestWizardStore.state.item.title}
            onChange={e => this.onManuallyChangeTitle(e.target.value)}
            onFocus={() => this.setState({ titleFocused: true })}
            onBlur={() => this.setState({ titleFocused: false })}
            className={`border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-600 transition ${
              titleFocused ? 'border-primary-600' : 'border-gray-300'
            }`}
          />
        </div>

        <div className="flex flex-col">
          <label className="mb-2 text-sm font-medium text-gray-700">{t('Comments')}</label>
          <textarea
            className="border rounded px-3 py-2 resize-none min-h-[30vh] max-h-[30vh] focus:outline-none focus:ring-2 focus:ring-primary-600 transition"
            value={this.requestWizardStore.state.item.comments}
            onChange={value => this.handleValue(nameof<RequestWizardData>('comments'), value.target.value)}
            placeholder={t('Add any comments')}
          />
        </div>
      </form>
    );
  }
}

export default withTranslation()(TailwindStepComments);
